import { render, staticRenderFns } from "./s_5_6.vue?vue&type=template&id=13477537&lang=true&"
import script from "./s_5_6.vue?vue&type=script&lang=js&"
export * from "./s_5_6.vue?vue&type=script&lang=js&"
import style0 from "./s_5_6.vue?vue&type=style&index=0&id=13477537&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
